// mostly copied from https://github.com/remarkjs/remark-external-links

import visit from 'unist-util-visit'
// eslint-disable-next-line import/no-extraneous-dependencies
import absolute from 'is-absolute-url'

import { VisitNode } from './types'

const defaultTarget = '_blank'
const defaultRel = ['nofollow', 'noopener', 'noreferrer']
const defaultProtocols = ['http', 'https']

type ExtendedLiteralVisitNode = VisitNode & {
    url?: string
}

type OptionType = {
    target?: string
    rel?: string[]
    protocols?: string[]
}

export const autoLinks = (options: OptionType = {}) => {
    const target = options.target
    const rel = options.rel
    const protocols = options.protocols || defaultProtocols

    return (tree: VisitNode) => {
        visit(tree, (node: ExtendedLiteralVisitNode) => {
            if (node.type === 'link' || node.type === 'linkReference') {
                if (!node.url) {
                    return
                }

                if (node.url?.startsWith('www')) {
                    node.url = `https://${node.url}`
                }

                const indexOfProtocolDelimiter = node.url.indexOf(':')
                let protocol = node.url.slice(0, indexOfProtocolDelimiter >= 0 ? indexOfProtocolDelimiter : 0)

                if (!protocol) {
                    protocol = 'https'
                    node.url = `${protocol}://${node.url}`
                }

                if (absolute(node.url) && protocols.includes(protocol)) {
                    const data = node.data || (node.data = {})
                    const props = data.hProperties || (data.hProperties = {})

                    // @ts-expect-error ignore it
                    props.target = target || defaultTarget
                    // @ts-expect-error ignore it
                    props.rel = (rel || defaultRel).concat()
                }
            }
        })
    }
}
